import { gql } from '@apollo/client';

export const GET_NOTIFICATION_SETTINGS = gql`
  query GetNotificationSettings($portfolioID: ID!) {
    notificationSettings(portfolioID: $portfolioID) {
      id
      portfolioID
      telegramEnabled
      telegramChatID
      emailEnabled
      emailAddress
      exitLevelNotifications
      exitNotifyApproaching
      invalidationNotifications
      invalidationNotifyApproaching
      rapidMoversEnabled
      dailyDigestEnabled
      moverDustThreshold
      moverMaxPositions
      timezone
      dailyDigestHour
      createdAt
      updatedAt
    }
  }
`; 